<template lang="html">
  <div class="main">
    <div class="name">
      <div class="title">{{message.Sl190}}</div>
    </div>
    <div class="box">
      <div class="hiden">
      <comp-data></comp-data>
      </div>
      <span style="padding-left:60px">
        {{message.Nl142}}
      </span>
      <!-- <comp-notice></comp-notice> -->
    </div>
  </div>
</template>

<script>
import CompData from './statistics/statisticsData.vue'
export default {
  components: {
    CompData
  },
  data () {
    return {
      message: {
        Sl190: this.$lang.ui.system.l190,
        Nl142: this.$lang.ui.notice.l142,
      },
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped lang="css">
.main {
  position: relative;
  width: 100%;
  height: 90%;
}
.name {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.left {
  float: left;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.title {
  display: block;
  height: 100%;
  line-height: 50px;
  float: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
}
.box {
  position: absolute;
  width: 100%;
  min-width: 710px;
  top: 60px;
  bottom: 0;
}
.ticket-more {
  width: 100%;
  padding: 20px;
}
.cell {
  background-color: #fff;
  border-radius: 2px;
  padding: 30px 55px;
}
.bottom-button {
  text-align: right;
  width: 100%;
  padding: 25px;
}
.hiden {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
